// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"634f5aa3","141":"7dded1e8","260":"660452f1","659":"8b134e4d","937":"dab8a4c0"}[chunkId] + ".chunk.css";
};